import { PropsWithChildren, ReactNode, memo } from 'react';
import { cn } from 'utils';

import { STypography } from 'components/ui';

import { STileContainer, STileHeader } from './Tile.styled';

/**
 * Tile component
 * @param {Number, String} w - Tile width
 * @param {Number, String} h - Tile height
 * @param {String} title
 * @param {Node} header - Header component
 * @param {Node} children - Any
 */

type TileProps = {
  w: string;
  h: string;
  flex?: string;
  title?: string;
  header?: ReactNode;
  disabled?: boolean;
  noPadding?: boolean;
} & PropsWithChildren;

const Tile = memo<TileProps>(({ w, h, flex, title, header, disabled, noPadding, children }) => (
  <STileContainer w={w} h={h} flex={flex} disabled={disabled}>
    <div className="border relative w-full h-full rounded bg-background">
      {(title || header) && (
        <STileHeader className="bg-background border-b border-l border-r rounded-bl-lg rounded-br-lg">
          {title && (
            <STypography variant="caption" fontWeight={700} truncate>
              {title}
            </STypography>
          )}
          {header && header}
        </STileHeader>
      )}
      <div className={cn('w-full h-full overflow-auto', !noPadding && 'p-1 pt-7')}>
        {children && children}
      </div>
    </div>
  </STileContainer>
));

Tile.displayName = 'Tile';

export default Tile;
